const SET_STAGE_MOUSE_POSITION = 'scratch-gui/Stage/SET_MOUSE_POSITION';

const initialState = {
    mousePosition: {x: 0, y: 0}
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_STAGE_MOUSE_POSITION:
        if (action.mousePosition.x === state.mousePosition.x && action.mousePosition.y === state.mousePosition.y) {
            return state;
        }
        return {
            mousePosition: action.mousePosition
        };
    default:
        return state;
    }
};

const setMousePosition = function (x, y) {
    return {
        type: SET_STAGE_MOUSE_POSITION,
        mousePosition: {x: x, y: y}
    };
};

export {
    reducer as default,
    initialState as stageInitialState,
    setMousePosition
};
